import styled from 'styled-components';

export const StyledForm = styled('form')`
  //max-width: 720px;
  flex: 1 1 auto;
  position: relative;
  padding: 0 0 100px;
`;
